import { Link } from "react-router-dom";

const NeedHelpLink = ({ to = "" }) => {
  return (
    <div className="help text-sm text-[#e66553] py-4">
      <Link to={to}>Need help?</Link>
    </div>
  );
};

export default NeedHelpLink;
